import {
  Button,
  Flex,
  Squish,
  Stack,
  SvgEnvelope,
  SvgFriends,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useAddNewPeopleSuccessModalAnalytics } from 'src/components/AddNewPeopleSuccessModal/AddNewPeopleSuccessModalAnalytics';
import { AddNewPeopleSuccessModalContainer } from 'src/components/AddNewPeopleSuccessModal/AddNewPeopleSuccessModalContainer';
import { AddNewPeopleSuccessModalRow } from 'src/components/AddNewPeopleSuccessModal/AddNewPeopleSuccessModalRow';
import { MEAL_CREDIT_ENTITY_NAME } from 'src/constants/mealCredit';

export interface AddNewPeopleSuccessModalProps {
  onClose: () => void;
  employeeCount: number;
}

export function AddNewPeopleSuccessModal({
  onClose,
  employeeCount,
}: AddNewPeopleSuccessModalProps): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  const { push } = useHistory();

  const { sendAnalyticsBefore } = useAddNewPeopleSuccessModalAnalytics();

  return (
    <AddNewPeopleSuccessModalContainer
      employeeCount={employeeCount}
      onClose={onClose}
    >
      <Squish inset="md">
        <Stack y="md">
          <AddNewPeopleSuccessModalRow
            icon={<SvgFriends size="32px" />}
            heading={`You can assign people to your ${MEAL_CREDIT_ENTITY_NAME.singular}`}
            copy={`Assign people to your ${MEAL_CREDIT_ENTITY_NAME.singular} so they can start ordering through their Grubhub account.`}
          />
        </Stack>
        <Stack y="sm">
          <AddNewPeopleSuccessModalRow
            icon={<SvgEnvelope size="32px" />}
            heading="We’ll send welcome emails"
            copy={`Once people are assigned to an active ${MEAL_CREDIT_ENTITY_NAME.singular}, we’ll send them a welcome email with instructions to access their account.`}
          />
        </Stack>
      </Squish>
      <Squish as="footer" dimension="2" inset="md">
        <Flex>
          <Stack width="50%" x="sm">
            <Button
              block
              variant="secondary"
              buttonSize="medium"
              onClick={() =>
                sendAnalyticsBefore(onClose, {
                  eventaction: 'success module done_cta',
                })
              }
            >
              Done
            </Button>
          </Stack>
          <Stack width="50%">
            <Button
              block
              variant="primary"
              buttonSize="medium"
              onClick={() =>
                sendAnalyticsBefore(
                  () => push(`/corporate/management/${corpid}/lineOfCredit`),
                  { eventaction: 'success module loc_cta' }
                )
              }
            >
              {`View ${MEAL_CREDIT_ENTITY_NAME.plural}`}
            </Button>
          </Stack>
        </Flex>
      </Squish>
    </AddNewPeopleSuccessModalContainer>
  );
}
